import { RootState } from "../reducers";

export const getMeasurerState = ({ measurer }: RootState) => measurer && measurer.active;
